/**
 * THE SCOPE PICKER'S ONE STATE, shared by its two triggers (prototype v2, 2026-11-02).
 *
 * The header's crumb has always opened the organisation / site / plant panel (`HeaderScope`). The v2
 * page head draws its TITLE as the same picker ("Jamshoro ⌄", "Network ⌄"): one panel, one set of
 * columns, one selection, reached from either place. A second picker with its own state would be two
 * authorities over one choice, so the open flag lives here and `HeaderScope` stays the only thing that
 * draws the panel. `anchor` says where it opens: under the crumb, or under the page's title.
 *
 * `HeaderScope` also publishes whether there is anything to pick (`canPick`): with one organisation
 * and one site the title is plain text, as the crumb is.
 */
import { create } from 'zustand';

export type ScopeAnchor = 'header' | 'title';

interface ScopePickerState {
  open: boolean;
  anchor: ScopeAnchor;
  /** The page title's trigger, for the panel's position and for focus to return to. */
  titleEl: HTMLElement | null;
  canPick: boolean;
  setOpen: (open: boolean, anchor?: ScopeAnchor) => void;
  toggle: (anchor: ScopeAnchor) => void;
}

export const useScopePicker = create<ScopePickerState>((set, get) => ({
  open: false,
  anchor: 'header',
  titleEl: null,
  canPick: false,
  setOpen: (open, anchor) => set(anchor === undefined ? { open } : { open, anchor }),
  /* A press on the OTHER trigger while open moves the panel there rather than closing it. */
  toggle: (anchor) => {
    const s = get();
    set(s.open && s.anchor === anchor ? { open: false } : { open: true, anchor });
  },
}));
